import { HierarchyBuilder } from '~/utils/literature/hierarchy-builder'
import { hasSolrParams, solrPageResponseSchema } from '~/utils/solr/docs-response'

export function useHierarchy(bookId: MaybeRefOrGetter<string>) {
  const { data, suspense } = useQuery(useSolrQueryOptions({
    endpoint: 'literature',
    params: computed(() => ({ bookHierarchy: toValue(bookId) })),
    schema: solrPageResponseSchema,
    enabled: hasSolrParams,
  }))

  const { $parseStringToDocument } = useNuxtApp()

  const builder = new HierarchyBuilder($parseStringToDocument)

  return {
    data: computed(() => builder.buildEnhancedHierarchy(data.value?.response.docs ?? [])),
    suspense,
  }
}
